<template>
  <div class="container">
    <div class="padding-default row expanded">
      <div class="padding-default columns small-12 medium-8 medium-offset-2">
        <div class="panel pas row expanded">
          <div class="columns small-2 medium-2 large-1">
            <a :href="url" class="header-logo text-center">
              <img
                class="image"
                src="../../../dev/app/global/assets/images/logo-c.png"
              />
            </a>
          </div>

          <div class="columns small-10 medium-4 large-5">
            <p :class="textClass" :style="fontSize">
              You are logged into an Admin account viewing your public booking
              page
            </p>
          </div>

          <!-- <br v-if="!screenMediumAndUp" /> -->

          <div class="columns small-5 medium-3 ptm text-center">
            <a :href="url" class="button small radius btn-secondary">
              {{ viewText }}
            </a>
          </div>

          <div class="columns small-5 medium-3 ptm text-center" v-if="isOrganiser">
            <a :href="viewScheduleURL" class="button small radius btn-primary">
              {{ viewScheduleText }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PublicMainBanner',
  components: {},
  props: {},
  data() {
    return {
      isOrganiser: false,
      isCoach: false,
      url: '',
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    organiserOrCoach() {
      return this.isOrganiser || this.isCoach;
    },
    viewText() {
      return this.isOrganiser ? 'Manage Club' : 'View Registers';
    },
    viewScheduleText() {
      return 'View Schedule';
    },
    viewScheduleURL() {
      return '/cms/schedule';
    },
    screenMediumAndUp() {
      return this.window.width >= 1024;
    },
    screenSmallAndUp() {
      return !!(this.window.width > 640 && this.window.width < 1024);
    },
    fontSize() {
      if (this.screenSmallAndUp) {
        return 'font-size: 12px';
      }
      if (this.screenMediumAndUp) {
        return 'font-size: 14px';
      }
      return 'font-size: 11px';
    },
    textClass() {
      return this.screenMediumAndUp ? 'text-center text' : 'text-left text';
    },
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  beforeCreate() {},
  created() {
    this.isOrganiser = this.$root.$el.dataset.isOrganiser;
    this.isCoach = this.$root.$el.dataset.isCoach;
    this.url = this.$root.$el.dataset.redirectUrl;

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeMount() {},
  mounted() {},
  updated() {},
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
});
</script>

<style scoped>
.panel {
  background-color: #fff !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23) !important;
}

.container {
  position: sticky !important;
  top: 0 !important;
  padding: 0 !important;
  z-index: 1000 !important;
  max-width: 1280px !important;
  margin: 0 auto;
}

.image {
  padding: 5px 5px 5px 5px;
  min-height: 52px;
  max-height: 52px;
  min-width: 52px;
  max-width: 52px;
}

.btn-primary {
  background-color: #53c0b9;
}

.btn-secondary {
  background-color: #ff8364;
}

p {
  padding: 10px 0 10px 2px;
  margin: 0;
}



.row {
  margin: 0 !important;
  max-width: 100% !important;
}

.padding-default {
  padding: 6px 0 6px 0;
}
</style>
